import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/Dialog'
import type { useConfirmation } from '@/hooks/UseConfirmation'

interface ConfirmationDialogRendererProps<T = unknown> {
	confirmation: ReturnType<typeof useConfirmation<T>>
}

export function ConfirmationDialogRenderer<T = unknown>({ confirmation }: ConfirmationDialogRendererProps<T>) {
	const { isOpen, isConfirming, getDescription, confirm, action, cancel, config } = confirmation

	return (
		<Dialog open={isOpen} onOpenChange={(open) => !open && cancel()}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>{config.title}</DialogTitle>
				</DialogHeader>
				<p className="playbook-editor-modal-message">{getDescription()}</p>
				<div className="playbook-editor-modal-actions">
					<button
						onClick={cancel}
						disabled={isConfirming}
						className="playbook-editor-modal-button playbook-editor-modal-button--secondary"
					>
						{config.cancelText || 'Cancel'}
					</button>
					{config.actionText && config.onAction && (
						<button
							onClick={action}
							disabled={isConfirming}
							className={`playbook-editor-modal-button playbook-editor-modal-button--${config.actionVariant || 'default'}`}
						>
							{config.actionText}
						</button>
					)}
					<button
						onClick={confirm}
						disabled={isConfirming}
						className={`playbook-editor-modal-button playbook-editor-modal-button--${config.variant || 'destructive'}`}
					>
						{config.confirmText || 'Confirm'}
					</button>
				</div>
			</DialogContent>
		</Dialog>
	)
}
